/**
 * Stable CSS class names for E2E — MP application handler V2.
 */
export const MPAH = {
    page: 'mp-application-handler-v2-page',
    titleSection: 'mp-application-handler-v2-page__title-section',
    pageTitle: 'mp-application-handler-v2-page__title',
    actionsSection: 'mp-application-handler-v2-page__actions-section',
    inputButtonAddParameter: 'mp-application-handler-v2-page-input--button-add-parameter',
    filterSection: 'mp-application-handler-v2-page__filter-section',
    inputTextSearchName: 'mp-application-handler-v2-page-input--text-search-name',
    gridSection: 'mp-application-handler-v2-page__grid-section',
    gridWrap: 'mp-application-handler-v2-page__grid-wrap',

    datagridAndroidSwitchCell: 'mp-application-handler-v2-datagrid-android-cell',
    inputSwitchAndroid: 'mp-application-handler-v2-datagrid-input--switch-android',
    datagridIosSwitchCell: 'mp-application-handler-v2-datagrid-ios-cell',
    inputSwitchIos: 'mp-application-handler-v2-datagrid-input--switch-ios',
    datagridEditCell: 'mp-application-handler-v2-datagrid-actions-cell-edit',
    inputButtonRowEdit: 'mp-application-handler-v2-datagrid-input--button-row-edit',
    datagridDeleteCell: 'mp-application-handler-v2-datagrid-actions-cell-delete',
    inputButtonRowDelete: 'mp-application-handler-v2-datagrid-input--button-row-delete',
} as const;

export const mpahCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
